import empty_camera_snapshot from "src/assets/images/empty_camera_snapshot.jpg";
import OpacityView from "src/components/OpacityView";
import { radiusMedium } from "src/styles/radius";
import { paddingLarge } from "src/styles/spacing";
import { Image, Text } from "src/swsh-native";

const CommentsEmpty = () => {
	return (
		<OpacityView
			entering={false}
			exiting={true}
			style={{
				flex: 1,
				alignItems: "center",
				justifyContent: "center",
				marginVertical: paddingLarge,
				height: "100%",
			}}
		>
			<Image
				alt="Empty Search Results"
				src={empty_camera_snapshot}
				dim={{
					height: 200,
					width: 300,
				}}
				style={{
					borderRadius: radiusMedium,
					marginBottom: paddingLarge,
				}}
			/>
			<Text semibold>Start the convo</Text>
			<Text color="TextLight">No messages yet</Text>
		</OpacityView>
	);
};
export default CommentsEmpty;
